import { render, staticRenderFns } from "./DialogBase.vue?vue&type=template&id=167e9bd6&lang=html&"
import script from "./DialogBase.vue?vue&type=script&lang=js&"
export * from "./DialogBase.vue?vue&type=script&lang=js&"
import style0 from "./DialogBase.vue?vue&type=style&index=0&id=167e9bd6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports